const useScreen = () => {
  const screenWidth = ref(document.documentElement.clientWidth);
  const screenHeight = ref(document.documentElement.clientHeight);

  function handleResize() {
    screenWidth.value = document.documentElement.clientWidth;
    screenHeight.value = document.documentElement.clientHeight;
  }

  const oneThirdWidth = computed(() => {
    return Math.trunc(screenWidth.value / 3);
  });

  onMounted(() => window.addEventListener('resize', handleResize));
  onUnmounted(() => window.removeEventListener('resize', handleResize));

  return { screenHeight, screenWidth, oneThirdWidth };
};

export default useScreen;
